module.exports = __webpack_public_path__ + "img/zjyg1.4852b239.jpg";